import styles from './styles/login.module.scss';
import { Box, Menu, Typography } from '@mui/material';
import { Formik, Field, Form } from 'formik';
import GoogleButton from './GoogleButton';
import useSignin from './hooks/useSignIn';
import { useUser } from 'contexts';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button, Flex } from 'ui';
import Link from 'next/link';

function LoginMenu({ children }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mounted, setMounted] = useState(false);
  const { loading, profile, uid } = useUser();
  const open = Boolean(anchorEl);
  const login = useSignin();

  useEffect(() => setMounted(true), []);

  return (
    <>
      <Box
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(event) => {
          if (profile.name || loading) return;
          setAnchorEl(event.currentTarget);
        }}
      >
        {children}
      </Box>
      {mounted && !uid && (
        <Menu
          anchorEl={anchorEl}
          className={styles.login}
          id="basic-menu"
          onClose={() => setAnchorEl(null)}
          open={open}
        >
          <Typography>Bienvenido</Typography>
          <Formik initialValues={login.initialValues} onSubmit={login.onSubmit}>
            {({ isSubmitting }) => (
              <Form className={styles.root}>
                <Field
                  className={styles.field}
                  disabled={login.loading || isSubmitting}
                  placeholder="Correo electrónico"
                  name="email"
                  type="email"
                  required
                />
                <Field
                  className={styles.field}
                  disabled={login.loading || isSubmitting}
                  placeholder="Contraseña"
                  name="password"
                  type="password"
                  required
                />
                <Flex spacing={1}>
                  <Button
                    disabled={login.loading}
                    loading={isSubmitting}
                    variant="submit"
                    type="submit"
                  >
                    Iniciar sesión
                  </Button>
                  <GoogleButton
                    disabled={login.loading || isSubmitting}
                    variant="outlined"
                    rounded
                    minified
                  />
                </Flex>
                <Typography className={styles.redirect}>
                  ¿No tienes cuenta?{' '}
                  <Link href="/register" onClick={() => setAnchorEl(null)}>
                    Regístrate
                  </Link>
                </Typography>
              </Form>
            )}
          </Formik>
        </Menu>
      )}
    </>
  );
}

LoginMenu.propTypes = {
  profile: PropTypes.object,
  loading: PropTypes.bool,
};

export default LoginMenu;
